<template lang="pug">
md-layout(md-column)
  md-theme(md-name='blue')
    // Title
    breadcrumbs(section='Video Sources', :nav='nav')
    router-link(:to='{ name: "CreateVideoSource" }')
      md-button.md-fab.md-fab-bottom-right.md-icon-button
        md-icon(md-iconset="fa fa-plus")
    media-source-table.content-table
</template>

<script>
  import MediaSourceTable from '../../shared-components/mediaSource/MediaSourceTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    components: {
      MediaSourceTable,
      Breadcrumbs
    },
    computed: {
      nav() {
        return [
          { title: 'Video Sources' }
        ]
      },
    }
  };
</script>

<style lang="scss" scoped>
  .on-left {
    margin-top: -5px;
    margin-right: 5px;
  }
  .content-table {
    margin: 25px 10%;
    @media (max-width: 945px) {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/mediaSource/MediaSourceList.vue